const firstLetterCapitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

export default firstLetterCapitalize;
